import { __assign, __read } from "tslib";
import { KeyboardKey } from '@office-start/keystroke-handler-utility';
import { setupCloseHandlers, } from '@office-start/vanilla-js-modal';
import { createShareControl } from './createShareControl';
import styles from './shareStyles.module.scss';
var closeDialogEventName = 'share-control-close-event';
var closeHandler = function () {
    document.dispatchEvent(new CustomEvent(closeDialogEventName));
    removeEventListeners();
};
var keyboardHandler = function (ev) {
    switch (ev.key) {
        case KeyboardKey.Escape:
            ev.preventDefault();
            ev.stopPropagation();
            closeHandler();
            break;
        default:
            break;
    }
};
var addEventListeners = function () {
    document.addEventListener('keydown', keyboardHandler);
};
var removeEventListeners = function () {
    document.removeEventListener('keydown', keyboardHandler);
};
export function getControls(containerElement) {
    return setupCloseHandlers(containerElement, [
        'click',
        closeDialogEventName,
    ]);
}
export function openShareControl(shareProps, shareItemElement, shareStyles) {
    var iframeElement = document.createElement('iframe');
    var container = document.createElement('div');
    container.appendChild(iframeElement);
    shareItemElement.appendChild(container);
    var iframeStyles = shareStyles !== null && shareStyles !== void 0 ? shareStyles : {
        left: '50%',
        position: shareProps.shareUIPosition,
        top: shareProps.shareUITop,
    };
    var iframeStyleString = Object.entries(iframeStyles)
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return "".concat(key, ": ").concat(value);
    })
        .join(';');
    iframeElement.setAttribute('style', iframeStyleString);
    var setStyle = function (style) {
        iframeElement.style.width = style.width;
        iframeElement.style.height = style.height;
    };
    iframeElement.className = styles['share-control'];
    var controls = getControls(container);
    createShareControl(__assign(__assign({}, shareProps), { iframeElement: iframeElement, setStyle: setStyle }), controls);
    addEventListeners();
    return controls;
}
//# sourceMappingURL=openShareControl.js.map